import yup from 'utils/yup';

export const initialBreakData = {
  id: '' as any,
  name: '',
  length: 0,
  no_set_length: [] as any,
  paid: '' as any,
  cannot_end_early: [] as any,
  cant_end_break_early: [] as any,
  end_break_automatically: [] as any,
  notify_before_break_ends: [] as any,
};

export const breakRuleFormValidation = yup.object().shape({
  name: yup.string().required(),
  length: yup.number().when('no_set_length', {
    is: (value: any) => value.length === 0,
    then: yup.number().moreThan(0).required(),
  }),
});
